import { FC } from "react"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"

interface SectionContainerProps {
	children: React.ReactNode
	extraClasses?: string[]
	bg?: string
	radius?: number
	py?: number
	px?: number
}

export const SectionContainer: FC<SectionContainerProps> = ({
	children,
	extraClasses,
	bg = "transparent",
	radius = 0,
	py = 0,
	px = 16,
}) => {
	return (
		<div
			className={classNames([classes.container, ...(extraClasses ?? [])])}
			style={{ backgroundColor: bg, borderRadius: `${radius}px`, padding: `${py}px ${px}px` }}
		>
			{children}
		</div>
	)
}
